import React from "react";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import "../styles/cashManagement.scss";
import MiniCard from "./MiniCard";
import ZohoRedirection from "./ZohoRedirection";
import BankIcon from "assets/img/svg/svgComponents/BankIcon";
import { ReactComponent as CashIcon } from "assets/img/svg/cash-inhand.svg";
import { getDaysChip } from "modules/paymentManagement/utils";

const commonChipStyles = {
  fontFamily: "Gilroy-Medium",
  fontWeight: 800,
  position: "absolute",
  top: "-10px",
};
const viewReceiptBtnStyle = {
  fontFamily: "Gilroy-Medium",
  color: "#333333",
  fontSize: "14px",
};
const btnStyle = { fontSize: "14px" };

const CashLocationCard = ({
  location,
  onViewReceipts,
  onSendDeposit,
  onViewDeposit,
  title = "Cash in hand",
  isCheque = false,
  isWritePermission,
}) => {
  const chip = getDaysChip(location.daysLeftToDeposit);

  const handleDepositClick = () =>
    onSendDeposit(location.id, location.cashierOffice);
  const handleReceiptsClick = () =>
    onViewReceipts(location.id, location.cashierOffice);

  const handleViewDepositClick = () =>
    onViewDeposit(location.id, location.cashierOffice);

  const renderCashActions = () => {
    if (isCheque && location.cashInHand?.receiptsCount <= 0)
      return (
        <>
          <AButton
            variant="primary_filled"
            updatedStyle={btnStyle}
            onClick={handleDepositClick}
            disabled={true}
          >
            Send for deposit
          </AButton>{" "}
          <AButton
            variant="general"
            className="btn-text"
            updatedStyle={viewReceiptBtnStyle}
            onClick={handleReceiptsClick}
          >
            {isCheque ? "View all" : "View receipts"}
          </AButton>
        </>
      );
    if (location.cashInHand?.receiptsCount <= 0) return null;

    return (
      <>
        <AButton
          variant="primary_filled"
          updatedStyle={btnStyle}
          onClick={handleDepositClick}
          disabled={!isWritePermission}
        >
          Send for deposit
        </AButton>
        <AButton
          variant="general"
          className="btn-text"
          updatedStyle={viewReceiptBtnStyle}
          onClick={handleReceiptsClick}
        >
          {isCheque ? "View all" : "View receipts"}
        </AButton>
      </>
    );
  };

  const renderTransitActions = () => {
    if (location.depositInTransit?.receiptsCount <= 0) return null;
    return (
      <AButton
        variant="general"
        className="btn-text"
        updatedStyle={viewReceiptBtnStyle}
        onClick={handleViewDepositClick}
      >
        {"View deposited"}
      </AButton>
    );
  };

  return (
    <div className="cm-card">
      <div className="cm-card-header">
        <div></div>
        {!isCheque && chip && (
          <CustomChip
            style={commonChipStyles}
            bgColor={chip.bgColor}
            textColor={chip.textColor}
            text={chip.label}
          />
        )}
      </div>

      <div className="cm-card-title mt-2">
        {location.branchName} {location?.businessAreaDes}{" "}
      </div>
      <div className="cm-card-tags">
        <CustomChip text={location.officeType} color="default" />
        {location.ownership && (
          <CustomChip text={location.ownership} color="default" />
        )}
      </div>
      {!isCheque && <ZohoRedirection dayCount={location.daysLeftToDeposit} />}
      <div className="cm-card-sections">
        <MiniCard
          icon={<CashIcon />}
          title={title}
          isCheque={isCheque}
          date={`${location.cashInHand.fromDate} - ${location.cashInHand.toDate}`}
          amount={location.cashInHand.amount}
          receiptsCount={location.cashInHand.receiptsCount}
          actions={renderCashActions()}
          message={
            location.cashInHand.receiptsCount === 0
              ? `${isCheque ? "" : "No receipts yet"}`
              : ""
          }
        />

        <MiniCard
          icon={<BankIcon />}
          title="Deposit in-transit"
          date={`${location.depositInTransit.fromDate} - ${location.depositInTransit.toDate}`}
          amount={location.depositInTransit?.amount || 0}
          receiptsCount={location.depositInTransit.receiptsCount}
          message={
            location.depositInTransit.receiptsCount === 0
              ? "No deposits yet"
              : ""
          }
          isCheque={isCheque}
          actions={renderTransitActions()}
          statusChip={location.status}
        />
      </div>
    </div>
  );
};

export default CashLocationCard;
